import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=3437469d&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3437469d",
  null
  
)

export default component.exports